import { getRedirectUrls } from 'utils/platform';
import { Amplify } from 'aws-amplify';
import { awsConfig, env } from 'core/config';
import { AWS_REGION, bucketNames } from './constants';
import { configureTokenStorage } from './tokenStorage';

const { redirectSignIn, redirectSignOut } = getRedirectUrls(awsConfig);

interface BucketInfo {
  bucketName: string;
  region: string;
  paths?: Record<string, Record<string, string[] | undefined>>;
}

const buckets = bucketNames.reduce((acc, bucket) => {
  acc[bucket] = {
    bucketName: bucket,
    region: AWS_REGION
  };
  return acc;
}, {} as Record<string, BucketInfo>);

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: awsConfig.aws_user_pools_id,
      userPoolClientId: awsConfig.aws_user_pools_web_client_id,
      identityPoolId: awsConfig.aws_cognito_identity_pool_id,
      loginWith: {
        oauth: {
          domain: awsConfig.oauth.domain,
          scopes: awsConfig.oauth.scope ? awsConfig.oauth.scope : [],
          redirectSignIn: redirectSignIn ? [redirectSignIn] : [],
          redirectSignOut: redirectSignOut ? [redirectSignOut] : [],
          responseType: awsConfig.oauth.responseType,
          providers:
            awsConfig.aws_cognito_social_providers?.map((provider: string) =>
              provider.toLowerCase()
            ) || []
        },
        username: true,
        email: true
      }
    }
  },
  API: {
    GraphQL: {
      endpoint: env.GRAPHQL_ENDPOINT,
      region: AWS_REGION,
      defaultAuthMode: 'userPool'
    },
    Events: {
      endpoint: env.EVENTS_ENDPOINT,
      region: AWS_REGION,
      defaultAuthMode: 'userPool'
    }
  },
  Storage: {
    S3: {
      region: AWS_REGION,
      buckets
    }
  }
});

// try/catch: a sandboxed frame without allow-same-origin throws on window.top.
const isFramed = (() => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
})();

void configureTokenStorage({
  hostname: window.location.hostname,
  cookieDomain: env.COOKIE_DOMAIN,
  isFramed,
  ancestorOrigins: Array.from(window.location.ancestorOrigins ?? [])
});
